import { render, staticRenderFns } from "./password.reset.view.vue?vue&type=template&id=451e2c26&scoped=true"
import script from "./password.reset.view.vue?vue&type=script&lang=js"
export * from "./password.reset.view.vue?vue&type=script&lang=js"
import style0 from "./password.reset.view.vue?vue&type=style&index=0&id=451e2c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451e2c26",
  null
  
)

export default component.exports